<template>
  <v-container fluid>
    <iframe
        :src="iframeSrc"
        frameborder="0"
        :style="{ width: '100%', height: heightComponent }"
        @load="adjustHeight"
    ></iframe>
  </v-container>
</template>

<script>

export default {
  name: 'CommonHTMXComponent',
  props: {
    iframeSrc: {
      type: String,
      required: true,
    },
    height: {default: '100%'}
  },

  computed: {
    heightComponent() {
      return this.height + 'px'
    }
  },

  methods: {
    adjustHeight(event) {
      const iframe = event.target;
      try {
        iframe.style.height = iframe.contentWindow.document.body.scrollHeight + "px";
      } catch (error) {
        console.error("Не удалось изменить высоту iframe:", error);
      }
    },
  },

  data() {
    return {
      // heightComponent: ""
    };
  },

};
</script>
